/* Winstreak Vault — infinite scroll for collection grids.
   Progressive enhancement over Dawn's numbered pagination:
   watches a sentinel near the bottom, fetches the next page, appends the cards,
   and re-syncs after Dawn's facets (filter/sort) swap the grid. */
(function () {
  var container = document.getElementById('ProductGridContainer');
  if (!container || !('IntersectionObserver' in window)) return;

  var loading = false;
  var sentinel = null;
  var io = null;

  function grid() { return container.querySelector('#product-grid'); }
  function marker() { return container.querySelector('.vault-infinite[data-next-url]'); }
  function nextUrl() { var m = marker(); return m ? m.getAttribute('data-next-url') : null; }

  function hidePagination() {
    container.querySelectorAll('.pagination-wrapper, nav.pagination').forEach(function (el) {
      el.setAttribute('hidden', '');
    });
  }

  function onIntersect(entries) {
    for (var i = 0; i < entries.length; i++) { if (entries[i].isIntersecting) { load(); break; } }
  }

  // Recreate + re-observe every time. A fresh observe delivers a new initial
  // callback, so if the sentinel is still in view after a load it fires again
  // and chains until the viewport is filled (or there are no more pages).
  function placeSentinel() {
    var g = grid();
    if (!g) return;
    if (sentinel) sentinel.remove();
    sentinel = document.createElement('div');
    sentinel.className = 'vault-infinite-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    // Non-empty on purpose: Dawn's base.css hides `div:empty` (display:none),
    // which would make an empty sentinel invisible to IntersectionObserver.
    sentinel.appendChild(document.createElement('span'));
    g.parentNode.appendChild(sentinel);
    if (!io) io = new IntersectionObserver(onIntersect, { rootMargin: '600px 0px' });
    else io.disconnect();
    io.observe(sentinel);
  }

  function setBusy(on) { if (sentinel) sentinel.classList.toggle('is-loading', !!on); }

  function load() {
    if (loading) return;
    var url = nextUrl();
    if (!url) return;
    loading = true;
    setBusy(true);
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('#product-grid');
        var g = grid();
        if (incoming && g) {
          var frag = document.createDocumentFragment();
          incoming.querySelectorAll(':scope > li').forEach(function (li) { frag.appendChild(li); });
          g.appendChild(frag);
        }
        // advance the next-url marker to the fetched page's next
        var incomingMarker = doc.querySelector('.vault-infinite[data-next-url]');
        var m = marker();
        if (m) {
          if (incomingMarker) { m.setAttribute('data-next-url', incomingMarker.getAttribute('data-next-url')); }
          else { m.removeAttribute('data-next-url'); }
        }
        loading = false;
        if (nextUrl()) {
          placeSentinel();
        } else {
          if (io) io.disconnect();
          if (sentinel) { sentinel.remove(); sentinel = null; }
        }
      })
      .catch(function () { loading = false; setBusy(false); });
  }

  function sync() {
    // initial setup and re-setup after facets replace the grid
    if (sentinel) { sentinel.remove(); sentinel = null; }
    if (io) io.disconnect();
    if (!grid()) return;
    hidePagination();
    if (nextUrl()) placeSentinel();
  }

  function start() {
    sync();
    // Dawn's facets.js replaces the innerHTML of #ProductGridContainer on filter/sort.
    // Our card appends and sentinel moves happen inside .collection (a descendant),
    // so this non-subtree observer fires only on facet swaps, never on our own inserts.
    new MutationObserver(sync).observe(container, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
